
import WDButton from '../button/wd-button';
import WDActivity from '../modal/wd-activity';
import WDListSort from './wd-list-sort';
import WDListFormItem from './wd-list-form-item';
import WDUtil from '../../core/wd-util';
import { WDRestObject } from '../../core/fetch/index.js';
import WDApiCache from '../../core/fetch/wd-api-cache';

export default class WDListForm extends WDListSort
{
	constructor(config) 
	{
		//this gives us an empty form in case there are no results for the fetch,
		//which gives us a starting point for entering new data
		/*
		config.noResults = () =>
		{
			//return this.noResults();
		};
		*/
		super(config).classList.add('wd-list-forms');

		if (config.allow_add) this.header.addButton({'fasIcon':'plus'});
		if (config.allow_remove) this.header.addButton({ 'fasIcon': 'trash' });

		if (config.buttons)
		{
			config.buttons.forEach(btnCfg => this.header.addButton(btnCfg) );
		};

		//add the forms - they will be populated by the item data
		config.forms.forEach(formItem =>
		{
			const cell = this.header.add(formItem.label);
			if (formItem?.name) cell.classList.add(formItem?.name);
		});

		return this;
	};

	handleNoResults()
	{
		const item = wdc('<div class="no-items-wrapper"/>');
		const btn = new WDButton({ label: 'Add New Item', size: 'sm', theme: 'primary', fasIcon: 'plus' });
		btn.on('click', () => this.addFormItem());

		item.append(btn);
		this.single().add(item);
	};

	/**
		* localizes any remote data sources, fetches our rows
		*/
	load()
	{
		return new Promise((resolve, reject) =>
		{
			if (this.items.length == 0) 
			{
				this.handleNoResults();
				resolve([]);
			}

			this.fetchDataSources().then(() =>
			{
				this.req().then(() =>
				{
					resolve(this.proxy);
				});
			});

		});
	};

	fetchDataSources()
	{
		const ddForms = this.config.forms.filter(x => (x?.fetch != undefined || x?.saveFetch != undefined));

		console.log('Fetch data sources',ddForms.length);
		return new Promise((resolve, reject) =>
		{
			let formsLoaded = 0;

			if (ddForms.length == 0) resolve(true);

			ddForms.forEach( async form =>
			{
				const results = await form.fetch.req();
				form.options = results;

				//we already have loaded forms, update their options
				if (this.items.length > 0)
				{
					this.items.forEach(item =>
					{
						item.getForm(form.name).setOptions(results);
					});
				}

				//this.setFormOptions(results);

				/*
				if (results.length > 0)
				{

				}
				else
				{

				}

				if (form?.saveFetch == undefined) form.saveFetch = form.fetch;
				
				const reqURI = form.saveFetch.getReqURI();
				
				// Delete the fetch from the form config to prevent individual forms from fetching
				delete (form.fetch);

				// Check if this is a WDApiCache instance and data is already cached
				if (form.saveFetch instanceof WDApiCache && form.saveFetch.isCached())
				{
					const cachedResults = form.saveFetch.getCached();
					this.setFormOptions(form,cachedResults);

					formsLoaded++;
					if (formsLoaded == ddForms.length) resolve(true);
				}
				else
				{
					form.saveFetch.req().then(results =>
					{
						this.setFormOptions(form, results);

						formsLoaded++;
						if (formsLoaded == ddForms.length) resolve(true);

					}).catch(error => 
					{
						console.error('Error fetching data source for form:', form.name, error);
						formsLoaded++;
						if (formsLoaded == ddForms.length) resolve(true);
					});
				}
					*/

			});
		});

	};

	setupItemProxy(item, data)
	{
		if (data?.isProxy) 
		{
			item.proxy = data;
		}
		else if (data?.fetch) 
		{
			item.proxy = data.fetch;
		}
		else if (data?.uri) 
		{
			const p = new WDRestObject(data.uri);
			p.add(data);
			item.proxy = p;
		}
	};

	addListItem(item, data)
	{
		const itemIdx = item.index;

		this.setupItemProxy(item, data);

		if (this.config?.allow_sort) 
		{
			item.icon = 'fa-solid fa-sort';
		}

		if (this.config?.allow_add) 
		{
			const btn = item.addButton({ fasIcon: 'plus' });
			if (this.config?.add_label) btn.label = this.config.add_label;
			btn.on('click', () => this.addFormItem(item));

		}

		if (this.config?.allow_remove || this.config?.allow_delete)
		{
			const btn = item.addButton({ fasIcon: 'trash' });
			if (this.config?.remove_label) btn.label = this.config.remove_label;
			btn.on('click', () => this.removeFormItem(item));

			//don't allow removal of the last item in the list
			if (item.index == '0') btn.style.visibility = 'hidden';
		}

		if (this.config.buttons)
		{
			this.config.buttons.forEach(btnCfg =>
			{
				const btn = item.addButton();

				if (btnCfg.text) btn.label = btnCfg.text;
				if (btnCfg.icon) btn.icon = btnCfg.icon;
				if (btnCfg.click) btn.on('click', () => btnCfg.click(item));

			});
		}

		//pointer for later
		const forms = this.config?.forms || [];
		const lastForm = forms.length > 0 ? forms[forms.length-1] : null;

		forms.forEach(async formItem =>
		{
			//clone the formItem.  The variables are stomping on each other
			const formCfg = WDUtil.merge({wrapper_class:'col-12'}, formItem);

			item.add(formCfg).then( newForm =>
			{
				//if we update an option list, re-cache all our data sources.
				//eventually just fetch the updated source so it's cached again
				newForm.on('options:updated', () => this.fetchDataSources());
				newForm.on('change', () =>
				{
					if (this.fetch)
					{
						//run this in a timeout so other events watching for changes can 
						//fire before we autosave.  Allows us to run triggers on the data
						setTimeout( () => {
							item.post().then(results =>
							{
								this.trigger('item:updated', item);
							});
						},250);
						
					}
					else
					{
						this.trigger('item:updated', item);
					}
				});

				//allow us to watch for specific form
				this.trigger('form:added',formItem);

				//all forms added, trigger the item has been updated
				if (formItem == lastForm)
				{
					this.trigger('item:added', item);
				}

			});

		});

		//if no forms were configured, trigger the item was added since
		//the form loop never runs
		if (!lastForm) this.trigger('item:added',item);

		return item;
	};

	/**
		* overwrite createItem so we can use our FormsItem instead
		*/
	createItem()
	{
		return new WDListFormItem(this);
	};

	addFormItem(item)
	{
		const position = (item) ? item.index + 1 : '0';

		if (this.fetch)
		{
			const p = new WDRestObject(this.config.fetch.getReqURI());
			this.proxy.insert(position, p);
		}
		else
		{
			this.proxy.insert(position, item || {});
		}

	};

	removeFormItem(item)
	{
		//if not set, or set to true - new syntax for me
		if (this.config?.delete_confirm ?? true)
		{
			new WDActivity().showDelete(() => this.runRemoveFormItem(item));
		}
		//no confirmation, just do
		else
		{
			this.runRemoveFormItem(item);
		}
	};

	runRemoveFormItem(item)
	{
		const uri = item.proxy.getReqURI();

		//delete the item if it was saved (how can we tell?)
		if ( this.fetch && uri != this.fetch.getReqURI() )
		{
			item.proxy.del().then(() =>
			{
				this.proxy.remove(item.index);
				this.trigger('item:removed');
			});
		}
		else
		{
			this.proxy.remove(item.index);
			this.trigger('item:removed');
		}
	};

	formHasValue(itemData)
	{
		let ret = false;

		Object.values(itemData).some(val =>
		{

			if (typeof (val) == 'object')
			{
				if (val instanceof Array && val.length > 0) 
				{
					ret = true;
				}
			}
			else if (String(val).length > 0)
			{
				ret = true;
			}

			if (ret == true) return true;

		});

		return ret;
	};

	get value()
	{
		const data = [];
		this.items.forEach(item => {
			const itemData = item.value;

			//ignore empty rows
			if (this.formHasValue(itemData)) data.push(itemData);
		});

		return data;
	};

	set value(vals)
	{
		this.reset();

		vals.forEach((val, idx) => {
			const item = this.insert();
			item.value = val;
		});
	};

};

customElements.define('wd-list-form', WDListForm);
